// @flow

import { combineReducers, type Reducer } from 'redux';

import type { Catalog } from '@gandi/cart';
import {
  createSequoiaResource,
  type SequoiaResource,
  type SequoiaResourceType,
  type ListState,
  type ResourceAction,
} from '@gandi/resource/redux';

export type ProductSummary = {
  label: string,
  config_name: string,
  prices: Array<{ ...Catalog, currency: string }>,
  taxes: Array<{
    rate: number,
  }>,
  config: [
    {
      uuid: string,
      name: string,
      label: string,
      quota_kb: number,
    },
  ],
};

export type State = {
  list: ListState<ProductSummary>,
};

export type ProductsResourceType = SequoiaResourceType<{
  fetchResource: ProductSummary,
  fetchOneResource: empty,
}>;

export type ProductsResource = SequoiaResource<ProductsResourceType>;

export const productsResource: ProductsResource = createSequoiaResource(
  'mailbox-standalone',
  'products',
  {
    fetchPath: 'mailboxsa-anonymous/products',
    getResourceId(resource) {
      return resource.config_name;
    },
  },
);

export const reducer: Reducer<State, ResourceAction<>> = combineReducers({
  ...productsResource.listReducer,
});
